import React from 'react';
import { X } from 'lucide-react';
import type { PublisherConfig } from '../../../types/selfService';
import { displayedName } from '../../../data/publisherConfigs';
import { tintFromAccent } from '../steps/_shared';

interface StationHelpModalHeaderProps {
  config: PublisherConfig | null | undefined;
  onClose: () => void;
}

const StationHelpModalHeader: React.FC<StationHelpModalHeaderProps> = ({ config, onClose }) => {
  const accent = config?.accentColor || config?.primaryColor;

  if (!config) {
    return (
      <div className="relative flex items-center justify-between gap-3 px-5 py-3 border-b border-slate-200 bg-white">
        <span className="text-sm font-semibold text-slate-900">Support</span>
        <button
          type="button"
          onClick={onClose}
          className="p-1 rounded-md text-slate-500 hover:bg-slate-100 shrink-0"
          aria-label="Close"
        >
          <X className="w-5 h-5" />
        </button>
      </div>
    );
  }

  const label = displayedName(config);

  return (
    <div className="relative bg-white/90 border-b border-slate-200/80">
      <div className="flex items-center justify-between gap-3 px-5 py-3">
        <div className="flex items-center gap-3 min-w-0">
          {config.logoUrl ? (
            <img
              src={config.logoUrl}
              alt={label}
              className={`h-6 w-auto object-contain shrink-0 ${config.logoInvert === true ? 'brightness-0 invert' : ''}`}
              style={
                config.logoScale && config.logoScale !== 1
                  ? { transform: `scale(${config.logoScale})`, transformOrigin: 'left center' }
                  : undefined
              }
            />
          ) : (
            <div
              className="h-7 w-7 rounded-md flex items-center justify-center text-white font-semibold text-sm shrink-0"
              style={{ backgroundColor: accent }}
            >
              {label.charAt(0)}
            </div>
          )}
          <div className="min-w-0">
            <div className="text-sm font-semibold text-slate-900 truncate">{label}</div>
            <div className="text-[10px] font-medium uppercase tracking-[0.12em] text-slate-500">
              Support
            </div>
          </div>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="p-1 rounded-md text-slate-500 hover:bg-slate-100 shrink-0"
          aria-label="Close"
        >
          <X className="w-5 h-5" />
        </button>
      </div>
      {accent && (
        <span
          aria-hidden
          className="pointer-events-none absolute bottom-0 left-0 right-0 h-px"
          style={{
            background: `linear-gradient(90deg, transparent, ${tintFromAccent(accent, 0.55)}, transparent)`,
          }}
        />
      )}
    </div>
  );
};

export default StationHelpModalHeader;
